<template>
    <div>
        <!-- 菜单 -->
        <my_menu2 page_name="公司开票与银行信息" back_type="close" back_icon="md-close"></my_menu2>
        <div style="height: 50px"></div>
        <div>
            <Table size="small" :columns="columns" :data="table_data" :height="windowHeight - 70">
                <template #bank="{ row }">
                    <Button @click="click_bank_list(row)" type="primary" size="small" style="font-size: 13px;">查看银行信息({{
                        row.bank_list.length
                        }})</Button>
                </template>

            </Table>

        </div>
        <Drawer title="公司银行列表" :closable="false" v-model="bank_list_show" width="80">
            <div>
                <div v-for="(item, i) in bank_list" :key="i" class="bank_card">
                    <div class="item_div">
                        <div class="item_field">
                            银行账号：
                        </div>
                          <div class="remarks">   {{ item.bank_num }}</div>
                    </div>
                    <div class="item_div">
                        <div class="item_field">
                            开户行：
                        </div>
                     
                             <div class="remarks">   {{ item.bank_full_name }}</div>
                    </div>
                    <div class="item_div">
                        <div class="item_field">
                            类型：
                        </div>
                          <div class="remarks">{{ item.bank_status == 0 ? '基本户' : '一般户' }}</div>
                        
                    </div>
                    <div class="item_div">
                        <div class="item_field">
                            联行号：
                        </div>
                         <div class="remarks">{{ item.joint_bank_number }}</div>
                        
                    </div>
                    <div class="item_div">
                        <div class="item_field">
                            备注：
                        </div>
                        <div class="remarks2">
                            {{ item.remarks?item.remarks:'--' }}
                        </div>

                    </div>
                </div>
            </div>
        </Drawer>

    </div>
</template>

<script>
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";

import my_menu2 from "@/component/menu/menu2.vue";
import { FormItem } from "view-ui-plus";
export default {
    components: {
        my_menu2,
    },
    data() {


        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            columns: [],
            table_data: [],
            bank_list: [],
            bank_list_show: false,
            project_id: ''
        }
    },
    mounted() {
        var query = this.$route.query
        this.project_id = query.project_id
        this.get_data()
    },
    methods: {
        click_bank_list(row) {
            this.bank_list_show = true
            this.bank_list = row.bank_list
        },
        //获取开票信息
        get_data() {
            var that = this;
            var obj = {
            };
            this.table_loading = true;
            http(
                "post",
                process.env.VUE_APP_HOST + "/finance/invoice/subject_public",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        console.log(res);
                        that.columns = res.data.columns;

                        that.table_data = res.data.table_data;
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.table_loading = false;
                })
                .catch((res) => {
                    that.table_loading = false;

                    console.log(res, "请求出错");
                });
        },
    }
}
</script>

<style scoped>
.remarks{
    color:#757575
}

.remarks2{
    color:red;font-size: 14px;
}

.item_div {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.bank_card {
    padding: 10px;
    border: 1px solid #ebebeb;
    border-radius: 5px;
    margin-bottom: 10px;
}

.item_field {
    width: 80px;
    font-weight: 600;
    flex-shrink: 0;
}
</style>